import { SearchParams } from 'location.types'
import { useSearchParams } from 'react-router'
import { getObject, LocalStorageKeys, setObject } from 'utils/storage'
import { EhrAppointmentAttendanceChargeKind, EhrAppointmentKind } from 'types'

const CUSTOMIZATION_SEARCH_PARAMS = [
  SearchParams.FlowKind,
  SearchParams.ShowRecurring,
  SearchParams.HideOnboarding,
  SearchParams.AppointmentKind,
  SearchParams.AppointmentChargeKind,
  SearchParams.DisableFakeSlots,
  SearchParams.BypassCreditCard,
  SearchParams.PendingAppointmentId,
  SearchParams.DaysOffset,
  SearchParams.AvailabilityWeeks,
  SearchParams.ForceKeggFlow
]

export enum FlowKind {
  Nutrition = 'nutrition',
  Stress = 'stress'
}

export type VideoCallsFlowCustomizationParamsType = {
  flowKind?: FlowKind
  showRecurring?: 'true' | 'false'
  hideOnboarding?: 'true' | 'false'
  disableFakeSlots?: 'true' | 'false'
  bypassCreditCard?: 'true' | 'false'
  forceKeggFlow?: 'true' | 'false'
  appointmentKind?: EhrAppointmentKind
  appointmentChargeKind?: EhrAppointmentAttendanceChargeKind
  pendingAppointmentId?: string
  daysOffset?: string
  availabilityWeeks?: string
}

export const useVideoCallsFlowCustomization = () => {
  const [searchParams] = useSearchParams()

  const captureCustomization = (): void => {
    const params: Record<string, string> = {}
    CUSTOMIZATION_SEARCH_PARAMS.forEach((param) => {
      const value = searchParams.get(param)
      if (value !== null) {
        params[param] = value
      }
    })
    setObject(LocalStorageKeys.VideoCallFlowCustomizationParams, params)
  }

  return {
    captureCustomization
  }
}

export const getVideoCallsFlowCustomizationParams = (
  searchParams: URLSearchParams | undefined = undefined
): VideoCallsFlowCustomizationParamsType => {
  const currentParams =
    getObject<VideoCallsFlowCustomizationParamsType>(
      LocalStorageKeys.VideoCallFlowCustomizationParams
    ) || {}

  const finalParams: Record<string, string> = { ...currentParams }
  if (searchParams) {
    CUSTOMIZATION_SEARCH_PARAMS.forEach((param) => {
      const value = searchParams.get(param)
      if (value !== null) {
        finalParams[param] = value
      }
    })
  }

  return finalParams
}

export const setVideoCallsFlowCustomizationParams = (
  params: VideoCallsFlowCustomizationParamsType
): void => {
  setObject(LocalStorageKeys.VideoCallFlowCustomizationParams, params)
}
